"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.horizontalRule = exports.blockQuote = exports.heading2 = exports.heading1 = exports.paragraph = void 0;
var Common_1 = require("ContentTokens/Models/Common");
var Text_1 = require("./Text");
var createBasicBlockEditorModel = function (type) {
    return {
        createToken: function () {
            return {
                type: "block",
                subType: type,
            };
        },
        createSlateJson: function (children) {
            return {
                type: type,
                children: children || [Text_1.text.createSlateJson()],
            };
        },
    };
};
exports.paragraph = createBasicBlockEditorModel(Common_1.BlockType.Paragraph);
exports.heading1 = createBasicBlockEditorModel(Common_1.BlockType.Heading1);
exports.heading2 = createBasicBlockEditorModel(Common_1.BlockType.Heading2);
exports.blockQuote = createBasicBlockEditorModel(Common_1.BlockType.BlockQuote);
exports.horizontalRule = {
    createToken: function () {
        return {
            type: "block",
            subType: "horizontalRule",
        };
    },
    createSlateJson: function () {
        return {
            type: Common_1.BlockType.HorizontalRule,
            isVoid: true,
            children: [],
        };
    },
};
